<div [class.d-none]="true">
  <ap-field #field [title]="question.label" [readonly]="true">
    <input appkit-field ngDefaultControl [formControl]="question.control" />
  </ap-field>
</div>
